module.exports = __webpack_public_path__ + "img/proyecto_8_mv.20609cf9.png";